import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateEventStage($companyId: ID!, $id: ID!, $attributes: EventStageAttributes!) {
    updateEventStage(companyId: $companyId, id: $id, attributes: $attributes) {
      eventStage {
        id
        ...UpdatedEventStage
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedEventStage on EventStage {
    id
    name
    notes
  }
`
